<template>
    <PopupRouterViewDetail label="Control Card For Delivery Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Control Card For Delivery" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" label-cols-lg="12" label="Control Card" id="fieldset-control-card" size="sm" :model.sync="model.controlCardId" :isRequired="true" :state="validateState('controlCardId')" :errorMessage="getErrorMessage(errorMessage.controlCardId, 'controlCardId')"   :selected="model.controlCard != null ? model.controlCard.controlCardNumber : ''" @input="getControlCards" @change="updateData" :isUpdatable ="true" :isSelectMethodExists="true" @onSelectMethod="setSelectedControlCard" />
						<app-input-textbox id="fieldset-qty-case" label-cols-lg="12"  label="Qty Case" label-for="input-qty-case" size="sm" :model.sync="model.qtyCase"  @change="updateData" :isUpdatable ="true"/>
						<app-input-textbox id="fieldset-qty-lock" label-cols-lg="12"  label="Qty Lock" label-for="input-qty-lock" size="sm" :model.sync="model.qtyLock"  @change="updateData" :isUpdatable ="true"/>
						<app-input-textbox id="fieldset-qty-outstanding" label-cols-lg="12"  label="Qty Outstanding" label-for="input-qty-outstanding" size="sm" :model.sync="model.qtyOutstanding"  @change="updateData" :isUpdatable ="true"/>
						<app-input-textbox id="fieldset-transaction-type" label-cols-lg="12"  label="Transaction Type" label-for="input-transaction-type" size="sm" :model.sync="model.transactionType"  @change="updateData" :isUpdatable ="true"/>
						<app-input-textbox id="fieldset-transaction-id" label-cols-lg="12"  label="Transaction Id" label-for="input-transaction-id" size="sm" :model.sync="model.transactionId"  @change="updateData" :isUpdatable ="true"/>
						<app-input-checkbox id="fieldset-is-is-used" label-cols-lg="12" label="Is Used" label-for="input-is-is-used" size="sm" :model.sync="model.isUsed" :isUpdatable ="true"checkedValue="Yes" uncheckedValue="No" @change="updateData" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ControlCardForDelivery from '@/models/ControlCardForDelivery/ControlCardForDelivery';
import ControlCardForDeliveryList from '@/models/ControlCardForDelivery/ControlCardForDeliveryList';
import ControlCardForDeliveryFilter from '@/filters/ControlCardForDelivery/ControlCardForDeliveryFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputCheckbox,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			controlCardId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				controlCardId: { required : "Control Card is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterControlCardForDelivery : null,
			currentControlCardForDeliveryPage : 1,
			controlCardForDeliveryPageSize: 10,
			sortByControlCardForDelivery: '',
			sortDescControlCardForDelivery: '',
			controlCards: [],
			controlCards: [],
			isControlCardComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isControlCardComboLoading: false,
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getControlCardForDelivery : async function(id) {
			this.isBusy = true;
			ControlCardForDelivery.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadControlCardForDelivery = true;
			this.filterControlCardForDelivery.id = this.modelId;
			ControlCardForDelivery.downloadDataDetail(this, this.filterControlCardForDelivery).then(result => {
				this.isDownloadControlCardForDelivery = false;
			}).catch(error => { this.isDownloadControlCardForDelivery = false; })
		},
		getControlCardForDeliverys : async function(input) {
			let filter = new ControlCardForDeliveryFilter();
			if (input != undefined) {
				filter.ControlCard = input;
			}
			this.isControlCardForDeliveryComboLoading = true;
			ControlCardForDelivery.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCardForDeliverys = result.data
				}
				this.isControlCardForDeliveryComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			filter.fwDocStat = '0,1';
			filter.exactType.fwDocStat = '1';
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedControlCardExecuted(item) {
			let _this = this;
			if(item == undefined || item == null) {
				this.model.controlCardId = null;
				this.model.controlCard = null;
				this.isBusy = true;
				ControlCardForDelivery.resetDocument(this, this.model.id).then(result => {
					this.getControlCardForDelivery(this.model.id).then(result => {
						this.gets();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			} else {
				this.model.controlCardId = item.id;
				this.model.controlCard = item;

				this.isBusy = true;
				ControlCardForDelivery.copyFromDocument(this, 'controlcard', item.id, this.model.id).then(result => {
					this.getControlCardForDelivery(this.model.id).then(result => {
						this.gets();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			}
		},
		setSelectedControlCard(item) {
			if(item) {
				var itemId = Number(item.id);
				if(this.model.controlCardId == itemId) return;
			}

			if(this.s != null && this.s.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap Control Card For Delivery akan me-reset form yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.setSelectedControlCardExecuted(item);
					}
				})
				.catch(err => {})
			} else {
				this.setSelectedControlCardExecuted(item);
			}
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.controlCardForDeliveryInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						ControlCardForDelivery.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'controlcardfordeliveryindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						ControlCardForDelivery.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'controlcardfordeliveryindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ControlCardForDelivery.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getControlCardForDelivery(id);
					});
				}
			});
		},
		onHidden() {
			this.getControlCardForDeliverys();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterControlCardForDelivery = new ControlCardForDeliveryFilter();
		//this.getControlCards();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getControlCardForDelivery(id);
			} else {
				this.modelId = id;
				this.getControlCardForDelivery(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
